// @generated by protoc-gen-es v2.13.0 with parameter "target=ts,import_extension=js"
// @generated from file polyester/api/options.proto (package polyester.api, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenExtension, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, extDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import type { MethodOptions } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_descriptor } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file polyester/api/options.proto.
 */
export const file_polyester_api_options: GenFile = /*@__PURE__*/
  fileDesc("Chtwb2x5ZXN0ZXIvYXBpL29wdGlvbnMucHJvdG8SDXBvbHllc3Rlci5hcGkqYQoOTUZBUmVxdWlyZW1lbnQSEwoPTUZBX1VOU1BFQ0lGSUVEEAASDgoKTUZBX1JFQ0VOVBABEhUKEU1GQV9GUkVTSF9TVEVQX1VQEAISEwoPTUZBX0NPTkRJVElPTkFMEAMqTAoUQXV0aGVudGljYXRpb25NZXRob2QSFAoQQVVUSF9VTlNQRUNJRklFRBAAEhEKDVNFU1NJT05fVE9LRU4QARILCgdBUElfS0VZEAI6OAoGcHVibGljEh4uZ29vZ2xlLnByb3RvYnVmLk1ldGhvZE9wdGlvbnMY0YYDIAEoCFIGcHVibGljOjgKBmhpZGRlbhIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGNKGAyABKAhSBmhpZGRlbjpoCg9tZmFfcmVxdWlyZW1lbnQSHi5nb29nbGUucHJvdG9idWYuTWV0aG9kT3B0aW9ucxjThgMgASgOMh0ucG9seWVzdGVyLmFwaS5NRkFSZXF1aXJlbWVudFIObWZhUmVxdWlyZW1lbnQ6fAoWYXV0aGVudGljYXRpb25fbWV0aG9kcxIeLmdvb2dsZS5wcm90b2J1Zi5NZXRob2RPcHRpb25zGNSGAyADKA4yIy5wb2x5ZXN0ZXIuYXBpLkF1dGhlbnRpY2F0aW9uTWV0aG9kUhVhdXRoZW50aWNhdGlvbk1ldGhvZHNCSlpIZ2l0aHViLmNvbS9GYWJyaWMtTGFicy9wb2x5ZXN0ZXItc2RrLWdvL2dlbi9wb2x5ZXN0ZXIvYXBpO3BvbHllc3RlcmFwaXYxYgZwcm90bzM=", [file_google_protobuf_descriptor]);

/**
 * MFARequirement describes the interactive MFA assurance documented for an RPC.
 *
 * @generated from enum polyester.api.MFARequirement
 */
export enum MFARequirement {
  /**
   * No interactive MFA requirement is declared; documentation treats this as none.
   *
   * @generated from enum value: MFA_UNSPECIFIED = 0;
   */
  MFA_UNSPECIFIED = 0,

  /**
   * The RPC requires recently completed interactive MFA. Stale assurance must be renewed.
   *
   * @generated from enum value: MFA_RECENT = 1;
   */
  MFA_RECENT = 1,

  /**
   * The RPC always requires a fresh, single-use step-up proof, even when MFA was completed recently.
   *
   * @generated from enum value: MFA_FRESH_STEP_UP = 2;
   */
  MFA_FRESH_STEP_UP = 2,

  /**
   * The required MFA level depends on the request.
   *
   * @generated from enum value: MFA_CONDITIONAL = 3;
   */
  MFA_CONDITIONAL = 3,
}

/**
 * Describes the enum polyester.api.MFARequirement.
 */
export const MFARequirementSchema: GenEnum<MFARequirement> = /*@__PURE__*/
  enumDesc(file_polyester_api_options, 0);

/**
 * AuthenticationMethod identifies a credential type accepted by an RPC.
 *
 * @generated from enum polyester.api.AuthenticationMethod
 */
export enum AuthenticationMethod {
  /**
   * No authentication method was specified.
   *
   * @generated from enum value: AUTH_UNSPECIFIED = 0;
   */
  AUTH_UNSPECIFIED = 0,

  /**
   * A bearer token for an interactive user session.
   *
   * @generated from enum value: SESSION_TOKEN = 1;
   */
  SESSION_TOKEN = 1,

  /**
   * A signed API key request.
   *
   * @generated from enum value: API_KEY = 2;
   */
  API_KEY = 2,
}

/**
 * Describes the enum polyester.api.AuthenticationMethod.
 */
export const AuthenticationMethodSchema: GenEnum<AuthenticationMethod> = /*@__PURE__*/
  enumDesc(file_polyester_api_options, 1);

/**
 * When true, this RPC is publicly accessible (no auth required).
 *
 * @generated from extension: bool public = 50001;
 */
export const public$: GenExtension<MethodOptions, boolean> = /*@__PURE__*/
  extDesc(file_polyester_api_options, 0);

/**
 * When true, this RPC is excluded from generated docs artifacts (nav/connect/openapi).
 * Use this for internal-only helper RPCs (e.g. intra-service calls).
 *
 * @generated from extension: bool hidden = 50002;
 */
export const hidden: GenExtension<MethodOptions, boolean> = /*@__PURE__*/
  extDesc(file_polyester_api_options, 1);

/**
 * Interactive MFA assurance documented for this RPC.
 * This metadata does not enforce runtime authorization.
 *
 * @generated from extension: polyester.api.MFARequirement mfa_requirement = 50003;
 */
export const mfa_requirement: GenExtension<MethodOptions, MFARequirement> = /*@__PURE__*/
  extDesc(file_polyester_api_options, 2);

/**
 * Credential types accepted by this RPC. When omitted on a protected RPC,
 * documentation defaults to session tokens and API keys. Public RPCs expose
 * no authentication methods. This metadata does not enforce runtime authorization.
 *
 * @generated from extension: repeated polyester.api.AuthenticationMethod authentication_methods = 50004;
 */
export const authentication_methods: GenExtension<MethodOptions, AuthenticationMethod[]> = /*@__PURE__*/
  extDesc(file_polyester_api_options, 3);

